import {
  PaymentChannel,
  api,
  type ICreditCardSettings,
} from '@setplex/tria-api'
import type { Store } from 'effector'
import { CreditCardsIcons } from './index.h'
import { getSecuredCreditCardNumber } from './lib'

export const $savedCreditCards = api.creditCards.$savedCreditCards.map(
  (creditCards) => {
    return (
      creditCards?.map(({ number, type, ...rest }) => {
        return {
          icon: CreditCardsIcons[type],
          number: getSecuredCreditCardNumber({ number }),
          ...rest,
        }
      }) ?? null
    )
  }
)
export const $creditCardsSettings: Store<Array<ICreditCardSettings> | null> =
  api.creditCards.$creditCardsSettings

export const $authorizeCreditCardSettings =
  $creditCardsSettings.map<ICreditCardSettings | null>((settings) => {
    const authorizeSettings = settings?.find(
      ({ paymentChannel }) => paymentChannel === PaymentChannel.AuthorizeNet
    )

    return authorizeSettings || null
  })
